import React from "react";

import PictureTextLeft from "../../PictureTextLeft/PictureTextLeft";
import styles from './Purpose.module.scss';

export default function Purpose() {
  return (
    <div className={styles.container}>
      <PictureTextLeft
        imageUrl="/images/landing_page_pipfarm/image.png"
        imageAlt="Trading chart"
        imageWidth={608}
        imageHeight={411}
        paragraphTitle="Bạn có thể chia sẻ hoàn cảnh thành lập và sứ mệnh của thương hiệu PipFarm không?"
        paragraphContent={[
          'Ngành giao dịch trực tuyến đã rất phát triển trên toàn cầu, nhưng gần đây một mô hình kinh doanh mới liên quan đã xuất hiện: giao dịch quỹ. Đây là mô hình rất giống với giao dịch truyền thống với các sàn môi giới, nhưng bạn không cần phải nạp tiền. Thay vào đó, bạn mua các thử thách giao dịch. Nếu bạn vượt qua thử thách, quỹ sẽ cung cấp tài khoản cấp vốn, và bạn giữ phần lớn lợi nhuận mà mình tạo ra trong khi chịu rủi ro tối thiểu.',
          'PipFarm khác biệt với các quỹ khác vì chúng tôi tập trung vào việc thưởng cho kinh nghiệm, sự nhất quán và lòng trung thành qua chương trình power-up độc đáo. Sứ mệnh của chúng tôi là thưởng cho các nhà giao dịch vì sự nhất quán của họ và giúp họ trở thành nhà giao dịch tốt nhất có thể.',
        ]}
        imageOrder={1}
        textOrder={2}
      />
    </div>
  );
}
